import { CaseExtendedModel, ExpenseModel } from 'api/model';
import {
  useExpenseDeleteExpenseHook,
  useExpenseSaveExpenseHook,
} from 'api/expense/expense';
import { useCallback, useMemo } from 'react';
import { useApiCallFn } from 'hooks/useApiCallFn';

const useExpenseActions = (
  currentCase: CaseExtendedModel | undefined,
  currentCaseWasUpdated: () => Promise<any>
) => {
  const saveExpense = useExpenseSaveExpenseHook();
  const deleteExpense = useExpenseDeleteExpenseHook();

  const saveExpenseCall = useApiCallFn((expense: ExpenseModel) =>
    saveExpense(expense)
  );
  const deleteExpenseCall = useApiCallFn((expense: ExpenseModel) =>
    deleteExpense(expense)
  );

  const handleSaveExpense = useCallback(
    async (expense: ExpenseModel) => {
      const [, error] = await saveExpenseCall.run(expense);

      if (!error) {
        await currentCaseWasUpdated();
      }
    },
    [currentCaseWasUpdated, saveExpenseCall]
  );
  const handleDeleteExpense = useCallback(
    async (expense: ExpenseModel) => {
      const [, error] = await deleteExpenseCall.run(expense);

      if (!error) {
        await currentCaseWasUpdated();
      }
    },
    [currentCaseWasUpdated, deleteExpenseCall]
  );

  return useMemo(
    () => ({
      onSaveExpense: handleSaveExpense,
      onDeleteExpense: handleDeleteExpense,
      saveExpenseStatus: saveExpenseCall.status,
      deleteExpenseStatus: deleteExpenseCall.status,
    }),
    [
      deleteExpenseCall.status,
      handleDeleteExpense,
      handleSaveExpense,
      saveExpenseCall.status,
    ]
  );
};

export default useExpenseActions;
